import { Component, OnInit ,Input,Output,EventEmitter} from '@angular/core';
import {GlobalDataService} from '../../services/global-data.service';

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.css']
})
export class TransactionHistoryComponent implements OnInit {

    @Input() id:any;
    @Input() vin?:any;
    @Output() acknowledge: EventEmitter<any> = new EventEmitter(false);

    public leadTransactions:any;
    public caseTransactions:any;
    public ownerTransactions:any;
    public ownersByVin:any;
    public userTZ='';
    public accordian_t=false;
  constructor(private _globalService:GlobalDataService) { }
  
  ngOnInit() {
      this.getLeadsTransaction();
      this.getCasesTransaction();
      this.getOwnersTransaction();
      this.userTZ = this._globalService.USER_TZ;
      if(sessionStorage.getItem("isVin")=="true")
      this.getOwnersByvin();
  }


    getLeadsTransaction(){
        this._globalService.getLeadsTransaction(this.id,(result)=>{
            this.leadTransactions = result;
        })
    }
    
    getCasesTransaction(){
        this._globalService.getCasesTransaction(this.id,(result)=>{
            this.caseTransactions = result;
        })
    }
    
    getOwnersTransaction(){
        this._globalService.getOwnersTransaction(this.id,(result)=>{
            this.ownerTransactions = result;
            if (this.ownerTransactions.length!=0){
                 this.acknowledge.emit(true);
            }
        })
    }
    
    getOwnersByvin(){
        this._globalService.getOwnersByvin(this.vin,(result)=>{
            this.ownersByVin = result;
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/utility/transaction-history/transaction-history.component.ts